import { RaidPlanAssignmentEntity } from 'app/frontend/types/custom/RaidPlan'
import { ResolvedAssignmentEntity } from './eventActivityTimelineResolver'

export const getResolvedAssignmentLabelEntity = ({
  resolvedEntity,
  fallbackEntity,
}: {
  resolvedEntity?: ResolvedAssignmentEntity
  fallbackEntity: RaidPlanAssignmentEntity
}) => {
  if (resolvedEntity?.kind === 'aggregate') {
    return resolvedEntity.sourceEntity
  }
  return fallbackEntity
}
